import React from 'react';
import { Grid } from 'semantic-ui-react';

import EventSummarySchedule from 'components/EventSummarySchedule';
import FertilizerEventSummaryProducts from './components/FertilizerEventSummaryProducts';
import FertilizerEventSummaryBlocks from './components/FertilizerEventSummaryBlocks';
import FertilizerEventSummaryApplication from './components/FertilizerEventSummaryApplication';
import { FERTILIZER_EVENT_WIZARD_SCHEDULE_STEP } from '../../constants';

interface Props {
    readOnly?: boolean;
}

export default function FertilizerEventSummaryPage(
    props: Props
): React.ReactElement {
    const { readOnly = false } = props;

    return (
        <div className="spray-event-modal-step || spray-event-summary">
            <Grid>
                <Grid.Row>
                    <Grid.Column width="8">
                        <h4 className="summary-title">Review Summary</h4>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <EventSummarySchedule
                readOnly={readOnly}
                eventWizardStep={FERTILIZER_EVENT_WIZARD_SCHEDULE_STEP}
            >
                <FertilizerEventSummaryBlocks />
            </EventSummarySchedule>
            <FertilizerEventSummaryApplication readOnly={readOnly} />
            <FertilizerEventSummaryProducts readOnly={readOnly} />
        </div>
    );
}
